﻿import { hardwareCommandsOps } from "../api/operations";
import { ROLE } from "../Auth/useRole";
import { entityFactory } from "../hooks/useEntity";
import { shortTimeFormat } from "../helpers/timeUtils";
import dayjs from "dayjs";
import { defineEntity } from "../api/entity";

export function rangeFilterUTC(filter: { from?: string; to?: string }) {
  return {
    ...filter,
    createdTo: filter?.to ? dayjs(filter?.to).utc().format(shortTimeFormat) : undefined,
    createdFrom: filter?.from ? dayjs(filter?.from).utc().format(shortTimeFormat) : undefined,
  };
}

const conf = defineEntity({
  ...entityFactory("hardware-commands"),
  endpoint: "hardware-commands",
  operations: hardwareCommandsOps,
  roleView: [ROLE.EMZ_DEVELOPER, ROLE.CONTAINER_ADMIN],
  roleAdmin: [ROLE.EMZ_DEVELOPER, ROLE.CONTAINER_ADMIN],
  baseRoute: "hardware-commands",
  singularName: (t) => t("Hardware Command"),
  name: (t) => t("Hardware Commands"),
  initialFilter: {
    sortBy: "receivedOn",
    sortOrder: "descend",
  },
  filterFormatter: rangeFilterUTC,
});

export default conf;
